import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

// Styles
import '../Fields.scss';
import './Checkbox.scss';

const Checkbox = (field) => (
  <div className="field">
    <label>
      <Field
        name={field.name}
        type="checkbox"
        component="input"
        value={field.value}
        onChange={field.onChange}
        disabled={field.disabled}
        className="field__checkbox"
      />
      <span className="field__checkbox__label">{field.label}</span>
    </label>
  </div>
);

Checkbox.contextTypes = {
  t: PropTypes.func,
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/app/components/forms/fields/checkbox/Checkbox.js